import React__default from 'react';
import { Done } from 'emotion-icons/material';
import Brandy from '../../Brandy/index.js';
import ListItem from '../../List/ListItem.js';
import { Bullets as Bullets$2 } from './Bullets.styles.js';

var Bullets = function Bullets(_ref) {
  var _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? [] : _ref$bullets,
    _ref$noSpacing = _ref.noSpacing,
    noSpacing = _ref$noSpacing === void 0 ? false : _ref$noSpacing;
  return /*#__PURE__*/React__default.createElement(Bullets$2, {
    className: "bullets",
    noSpacing: noSpacing
  }, bullets.map(function (bullet) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      className: "list-item",
      key: bullet.text,
      icon: /*#__PURE__*/React__default.createElement(Done, null),
      inPackageCard: true
    }, /*#__PURE__*/React__default.createElement(Brandy, {
      className: "brandy",
      text: bullet.text,
      variant: "body"
    }), bullet.disclaimer && /*#__PURE__*/React__default.createElement(Brandy, {
      className: "bullet-disclaimer",
      symbol: bullet.disclaimer.symbol,
      text: bullet.disclaimer.text,
      variant: "legal"
    }));
  }));
};
var Bullets$1 = Bullets;

export { Bullets$1 as default };
//# sourceMappingURL=Bullets.js.map
